import React, { useState, useCallback } from 'react'
import { requestPasswordReset } from 'actions/authActions'
import { useDispatch } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const ForgottenPassword = ({ setStateMessageRef, message }) => {
  const [email, setEmail] = useState('')
  const dispatch = useDispatch()

  const submitPasswordRecovery = useCallback(() => {
    setStateMessageRef.current('recovery-submitting', '')
    // the api is setup to return 200 success no mater what because we don't want someone
    // to be able to try random email addresssetStateMessageRefes and find that good ones return 200 and bad
    // ones return 401 but just make all callbacks use the same handler anyway.
    const callback = () => {
      setStateMessageRef.current('recovery-sent', 'A recovery email was sent if the address entered was found in the system.')
      setEmail('')
    }
    const errorCallback = () => {
      setStateMessageRef.current('error', 'An error occured sending the recovery email. Please reload the page and try again.')
      setEmail('')
    }
    const callbacks = {
      200: callback,
      400: callback,
      401: callback,
      404: errorCallback,
      419: errorCallback,
      500: errorCallback
    }
    dispatch(requestPasswordReset(email, callbacks))
  }, [email])

  return (
    <div className="recovery-content">
      {message != null
        ? (
        <div className="alert alert-danger" role="alert" data-cy="alert">
          <FontAwesomeIcon icon={['fas', 'exclamation-triangle']} size="1x" />
          {message}
        </div>
          )
        : null}
      <div className="login-text">
        Enter the email address associated with your account to send a password
        recovery email.
      </div>
      <input
        value={email}
        onChange={e => setEmail(e.target.value)}
        placeholder="Email"
        aria-label="recovery email input"
        className="form-control input-lg"
        type="text"
        autoFocus
        data-cy="email"
      />
      <div className="recovery-buttons">
        <button
          aria-label="cancel password recovery"
          className="btn btn-default"
          onClick={() => {
            setEmail('')
            setStateMessageRef.current('summit-login', null)
          }}
        >
          Cancel
        </button>
        <button
          aria-label="submit password recovery"
          className="btn btn-default"
          onClick={submitPasswordRecovery}
          disabled={
            /* super basic email validation */
            email === '' || !email.includes('@') || !email.includes('.')
          }
        >
          Send recovery email
        </button>
      </div>
    </div>
  )
}

export default ForgottenPassword
